const FAV_LIST_ICON_URL = 'https://cdn.shopify.com/s/files/1/0703/0551/3587/files/icon.svg?v=1780995013';

function replaceFavoritesListIcons(root = document) {
    root.querySelectorAll('.p-codebuy__section--favorites .p-codebuy__coordination_list_favorite_btn').forEach(btn => {
        const svg = btn.querySelector('svg[data-favorite-icon], svg');
        if (!svg) return;

        const img = document.createElement('img');
        img.className = 'p-codebuy__fav-list-icon';
        if (svg.classList.contains('ck-codebuy-favorited')) {
            img.classList.add('ck-codebuy-favorited');
        }
        img.src = FAV_LIST_ICON_URL;
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.dataset.favoriteIcon = '';
        svg.replaceWith(img);
    });
}

// CodeBuy モーダル：メイン画像の読み込み完了まで中身を隠し、
// 画像とコンテンツを同時にフェードイン（画像より先にコンテンツが出る違和感を防ぐ）
function manageCodebuyModalImageReveal() {
    const modal = document.querySelector('.ck-codebuy-modal');
    if (!modal) return;

    const isOpen = modal.classList.contains('is-open');

    if (!isOpen) {
        // 閉じたらリセット（次に開いたとき再びホールドできるように）
        modal.classList.remove('ck-codebuy-img-ready');
        delete modal.dataset.imgHoldInit;
        delete modal.dataset.imgBound;
        return;
    }

    // 開いた直後に一度だけ、表示し損ねを防ぐフォールバックを仕込む
    if (!modal.dataset.imgHoldInit) {
        modal.dataset.imgHoldInit = 'true';
        setTimeout(() => modal.classList.add('ck-codebuy-img-ready'), 2500);
    }

    // メイン画像が描画されたら load を待って表示（描画前は次回スケジュールで再試行）
    if (!modal.dataset.imgBound) {
        const mainImg = modal.querySelector(
            '.js-coordination-slider img, .p-codebuy__coordination_single_slider img'
        );
        if (mainImg) {
            modal.dataset.imgBound = 'true';
            const reveal = () => modal.classList.add('ck-codebuy-img-ready');
            if (mainImg.complete && mainImg.naturalWidth > 0) {
                reveal();
            } else {
                mainImg.addEventListener('load', reveal, { once: true });
                mainImg.addEventListener('error', reveal, { once: true });
            }
        }
    }
}

// CodeBuy カートボタンが disabled（売り切れ）のとき「Add to Cart」を「Sold Out」に差し替える
// （SVGアイコンは保持。有効化されたら元の文言に戻す）
function updateCartButtonSoldOutLabel(root) {
    root.querySelectorAll('.p-codebuy__coordination_single_cart_btn button').forEach(btn => {
        const textNode = [...btn.childNodes].find(
            n => n.nodeType === Node.TEXT_NODE && n.textContent.trim()
        );
        if (!textNode) return;

        const isDisabled = btn.disabled || btn.hasAttribute('disabled');
        const label = textNode.textContent.trim();

        if (isDisabled && label === 'Add to Cart') {
            btn.dataset.originalLabel = label;
            textNode.textContent = 'Sold Out';
        } else if (!isDisabled && label === 'Sold Out' && btn.dataset.originalLabel) {
            textNode.textContent = btn.dataset.originalLabel;
        }
    });
}

function run() {
    syncRestockButtons(document);
    syncBodyStateWithCodebuyModal();
    manageCodebuyModalImageReveal();
    updateCartButtonSoldOutLabel(document);
    replaceFavoritesListIcons(document);
    const pages = document.querySelectorAll('.p-codebuy__page');
    if (pages.length === 0) return;
    pages.forEach(page => runOnPage(page));
}

function syncBodyStateWithCodebuyModal() {
    const body = document.body;
    if (!body) return;

    const isCodebuyModalOpen = !!document.querySelector('.ck-codebuy-modal.is-open');
    if (isCodebuyModalOpen) {
        body.classList.add('codebuy-modal-open');
        body.style.overflow = 'hidden';
        body.style.background = '#fff';
        return;
    }

    body.style.removeProperty('overflow');
    body.style.removeProperty('background');

    // スクロールバーが復帰して幅が戻るフレームではトランジションを無効のままにし、
    // 一覧サムネイルの伸縮アニメ（大きく→小さく）を防ぐ。幅が落ち着いてから解除。
    if (body.classList.contains('codebuy-modal-open')) {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => body.classList.remove('codebuy-modal-open'));
        });
    }
}

function syncRestockButtons(root) {
    const restockButtons = root.querySelectorAll('.restockButton, #BIS_trigger.restockButton, button#BIS_trigger');
    if (restockButtons.length === 0) return;

    // 商品フォーム／スティッキーATCのみを見る（関連商品カード等の誤判定を避ける）
    const addToCartButtons = root.querySelectorAll(
        'product-form-component .button.add-to-cart-button, .sticky-add-to-cart__button.add-to-cart-button'
    );
    const shouldShowRestock = [...addToCartButtons].some(btn => btn.disabled || btn.hasAttribute('disabled'));

    restockButtons.forEach(btn => {
        // AMP BIS がボタンを再生成しても表示が戻るよう、毎回明示的に同期する
        btn.style.setProperty('display', shouldShowRestock ? 'block' : 'none', 'important');
    });
}

// BIS アプリがバリアント変更後にボタンを差し替えるため、遅延リトライで再同期する
function syncRestockButtonsWithRetry() {
    syncRestockButtons(document);
    [50, 150, 300, 600, 1200].forEach(delay => {
        setTimeout(() => syncRestockButtons(document), delay);
    });
}

function runOnPage(page) {
    // .column-switcher-list を .l-codebuy__columns の上に移動
    const switcher = document.querySelector('.column-switcher-list');
    const columns = document.querySelector('.l-codebuy__columns');
    if (switcher && columns && columns.previousElementSibling !== switcher) {
        columns.parentNode.insertBefore(switcher, columns);
    }

    // 768px以上の時のみ、desktop側のプロフィール列をスライダー直下へ移動
    if (window.innerWidth >= 768) {
        const coordinationSlider = page.querySelector('.swiper.js-coordination-slider');
        const promoterColumn = page.querySelector(
            '.coordination-single-staff.desktop-only .l-codebuy__column.p-codebuy__coordination_single_right'
        );

        if (
            coordinationSlider &&
            promoterColumn &&
            promoterColumn.previousElementSibling !== coordinationSlider
        ) {
            coordinationSlider.insertAdjacentElement('afterend', promoterColumn);
        }
    }

    // クリックで active 移動 + 1カラム切り替え
    if (switcher && columns && !switcher.dataset.initialized) {
        switcher.dataset.initialized = 'true';
        const items = switcher.querySelectorAll('.column-switcher-item');

        const getDefaultCols = () => window.innerWidth >= 750 ? 4 : 2;

        // 初期値をカスタムプロパティ＆クラスで設定
        const initialCols = getDefaultCols();
        columns.style.setProperty('--col-count', initialCols);
        columns.classList.add(`cols-${initialCols}`);

        items.forEach((item, index) => {
            item.addEventListener('click', () => {
                if (item.classList.contains('active')) return;
                items.forEach(i => i.classList.remove('active'));
                item.classList.add('active');

                const cols = index === 0 ? 1 : getDefaultCols();

                const cards = [...columns.querySelectorAll('.l-codebuy__column')];

                if (document.startViewTransition) {
                    // 各カードに一時的に view-transition-name を付与
                    cards.forEach((card, i) => {
                        card.style.setProperty('view-transition-name', `codebuy-card-${i}`);
                    });

                    // クラス変更・カラム数更新をすべて transition 内で行うことで
                    // gap や justify-content の変化も before/after に含まれ滑らかに遷移する
                    const transition = document.startViewTransition(() => {
                        columns.className = columns.className.replace(/\bcols-\d+\b/g, '');
                        columns.classList.add(`cols-${cols}`);
                        columns.style.setProperty('--col-count', cols);
                    });

                    transition.finished.then(() => {
                        cards.forEach(card => card.style.removeProperty('view-transition-name'));
                    });
                } else {
                    // 非対応ブラウザはそのまま切り替え
                    columns.className = columns.className.replace(/\bcols-\d+\b/g, '');
                    columns.classList.add(`cols-${cols}`);
                    columns.style.setProperty('--col-count', cols);
                }
            });
        });
    }

    // 単品ページ：figure の前に情報ラッパーを移動
    page.querySelectorAll('.p-codebuy__coordination_single_cart_product').forEach(product => {
        if (product.dataset.cartRestructured) return;
        product.dataset.cartRestructured = 'true';

        const figure = product.querySelector(':scope > figure');
        const firstTxt = product.querySelector(':scope > .p-codebuy__coordination_single_cart_txt');
        const quantity = product.querySelector(':scope > .p-codebuy__coordination_single_cart_quantity');

        if (!figure || !firstTxt || !quantity) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'p-codebuy__cart_info_wrapper';

        // firstTxt から quantity まで（inclusive）を収集
        const toWrap = [];
        let el = firstTxt;
        while (el) {
            toWrap.push(el);
            if (el === quantity) break;
            el = el.nextElementSibling;
        }

        // figure の直後に wrapper を挿入し、対象要素を移動
        figure.insertAdjacentElement('afterend', wrapper);
        toWrap.forEach(child => wrapper.appendChild(child));
    });

    // カートアクションの上に説明文を追加
    page.querySelectorAll('.p-codebuy__coordination_single_cart_action:not([data-desc-added])').forEach(action => {
        action.dataset.descAdded = 'true';
        const div = document.createElement('div');
        div.className = 'p-codebuy__coordination_single_cart_desc';
        div.textContent = '選択した商品をまとめてご購入いただけます';
        action.insertAdjacentElement('beforebegin', div);
    });

    // 「着用している商品」の上に h2 タイトルを追加
    page.querySelectorAll('#coordination-single-ttl-product:not([data-title-added])').forEach(h3 => {
        h3.dataset.titleAdded = 'true';
        const h2 = document.createElement('h2');
        h2.className = 'p-codebuy__coordination_single_wearing_ttl';
        h2.textContent = 'wearing items';
        h3.insertAdjacentElement('beforebegin', h2);
    });

    // カートボタンに SVG アイコンを追加 & スタイル付与
    const cartSvg = `<svg xmlns="http://www.w3.org/2000/svg" id="_レイヤー_1" data-name="レイヤー 1" viewBox="0 0 69.38 56.68"><defs><style>.cls-2{fill:none;stroke:#fff;stroke-width:5px;}</style></defs><path class="cls-2" d="M9.55,55.18h50.27c.98,0,1.82-.71,1.99-1.68l6.04-36.24c.2-1.23-.74-2.34-1.99-2.34H3.51c-1.24,0-2.19,1.12-1.99,2.34l6.04,36.24c.16.97,1,1.68,1.99,1.68Z"></path><path class="cls-2" d="M17.91,14.92v-6.71c0-3.71,3-6.71,6.71-6.71h20.13c3.71,0,6.71,3,6.71,6.71v6.71"></path></svg>`;

    page.querySelectorAll('.p-codebuy__coordination_single_cart_btn:not([data-cart-btn-styled])').forEach(p => {
        p.dataset.cartBtnStyled = 'true';
        p.style.display = 'flex';
        p.style.background = '#595353';
    });

    // SVG が未挿入のボタンに毎回チェックして挿入（CodeBuy の上書きに対応）
    page.querySelectorAll('#all-cart-in-button:not(:has(svg))').forEach(btn => {
        if (btn.textContent.trim()) btn.insertAdjacentHTML('afterbegin', cartSvg);
    });

    // quantity-btn の文字を SVG アイコンに置換
    const svgMinus = `<svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"></path></svg>`;
    const svgPlus = `<svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="vertical" d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"></path><path class="horizontal" d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"></path></svg>`;

    page.querySelectorAll('.quantity-btn.minus:not([data-svg-replaced])').forEach(btn => {
        btn.dataset.svgReplaced = 'true';
        btn.innerHTML = svgMinus;
    });
    page.querySelectorAll('.quantity-btn.plus:not([data-svg-replaced])').forEach(btn => {
        btn.dataset.svgReplaced = 'true';
        btn.innerHTML = svgPlus;
    });

    // .p-codebuy__typeA_profile_list の ul の直後に span.view を追加
    page.querySelectorAll('.l-codebuy__column.p-codebuy__typeA_profile_list ul').forEach(ul => {
        if (!ul.nextElementSibling?.classList.contains('p-codebuy__typeA_view')) {
            const span = document.createElement('span');
            span.className = 'p-codebuy__typeA_view';
            span.textContent = 'view';
            ul.parentNode.insertBefore(span, ul.nextSibling);
        }
    });

    // モーダルの閉じるボタンに「Close」テキストを挿入
    document.querySelectorAll('.ck-codebuy-modal__close:not([data-close-labeled])').forEach(btn => {
        btn.dataset.closeLabeled = 'true';
        btn.textContent = 'Close';
    });

    // お気に入りボタンをカート列の直前に移動
    page.querySelectorAll('.l-codebuy__column.p-codebuy__coordination_single_cart:not([data-fav-moved])').forEach(cart => {
        const fav = page.querySelector('.p-codebuy__coordination_single_favorite_btn');
        if (fav && cart.previousElementSibling !== fav) {
            cart.dataset.favMoved = 'true';
            cart.parentNode.insertBefore(fav, cart);
        }
    });

    // お気に入りボタンに「Favorite」テキストを追加
    page.querySelectorAll('.p-codebuy__coordination_single_favorite_btn:not([data-fav-labeled])').forEach(btn => {
        btn.dataset.favLabeled = 'true';
        const span = document.createElement('span');
        span.textContent = 'Favorite';
        btn.appendChild(span);
    });

}

const moveDeleteBtn = (item) => {
    const deleteBtn = item.querySelector('.swym-delete-btn');
    const imageWrapper = item.querySelector('.swym-wishlist-image-wrapper');
    if (deleteBtn && imageWrapper && !imageWrapper.contains(deleteBtn)) {
        imageWrapper.appendChild(deleteBtn);
    }
};

// メニューの「Sale」テキストにクラスを付与
function labelSaleMenuItem() {
    document.querySelectorAll('.menu-drawer__menu-item-text.wrap-text:not([data-sale-labeled])').forEach(span => {
        if (span.textContent.trim() === 'Sale') {
            span.dataset.saleLabeled = 'true';
            span.classList.add('menu-item-text--sale');
        }
    });
}

const OBSERVER_OPTIONS = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'disabled', 'aria-disabled'],
};

// 一連の DOM 加工をまとめて実行する
function applyEnhancements() {
    run();
    labelSaleMenuItem();
    document.querySelectorAll('.swym-wishlist-item').forEach(moveDeleteBtn);
}

let scheduled = false;

// 監視を一時停止して加工 → 再開。自分自身の DOM 変更で監視が再発火する
// フィードバックループを防ぎ、複数の変化を 1 フレームに集約して負荷を下げる
function scheduleEnhancements() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
        scheduled = false;
        observer.disconnect();
        applyEnhancements();
        observer.observe(document.body, OBSERVER_OPTIONS);
    });
}

labelSaleMenuItem();

// childList / 関連属性の変化を監視（加工は scheduleEnhancements で集約実行）
const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
        if (m.type === 'childList') {
            scheduleEnhancements();
            return;
        }
        if (
            m.type === 'attributes' &&
            (m.attributeName === 'disabled' || m.attributeName === 'aria-disabled') &&
            m.target instanceof Element &&
            m.target.matches('.button.add-to-cart-button, .p-codebuy__coordination_single_cart_btn button')
        ) {
            scheduleEnhancements();
            return;
        }
        // .ck-codebuy-modal の class 変化（開閉）も検知
        if (
            m.type === 'attributes' &&
            m.attributeName === 'class' &&
            m.target instanceof Element &&
            m.target.classList.contains('ck-codebuy-modal')
        ) {
            scheduleEnhancements();
            return;
        }
        // お気に入りアイコンの class 変化（CodeBuy の状態切り替え）も検知
        if (
            m.type === 'attributes' &&
            m.attributeName === 'class' &&
            m.target instanceof Element &&
            m.target.matches('.p-codebuy__section--favorites [data-favorite-icon]')
        ) {
            scheduleEnhancements();
            return;
        }
    }
});

observer.observe(document.body, OBSERVER_OPTIONS);

// ページロード時・View Transitions ナビゲーション後にリトライ付きで実行
function runWithRetry() {
    applyEnhancements();
    // CodeBuy の非同期レンダリングに対応するため段階的にリトライ
    [100, 300, 600, 1200, 2500].forEach(delay => {
        setTimeout(applyEnhancements, delay);
    });
}

runWithRetry();

// Shopify の same-origin View Transitions 対応
document.addEventListener('pagereveal', runWithRetry);

// バリアント変更時: 再入荷ボタン再同期 + VIPポイント更新
document.addEventListener('variant:update', (event) => {
  syncRestockButtonsWithRetry();

  const variant = event.detail?.resource;
  if (!variant?.price) return;

  const points = Math.floor(variant.price * 100 / 1000000);
  const el = document.getElementById('vip-points');
  if (el) el.textContent = points;
});